import ReorderHubOrganizeByBrandPage from "@faire/prototype-playground/workspace/tf/reorder-hub-organize-by-brand";
import ReorderHubOrdersPageEntrypointPage from "@faire/prototype-playground/workspace/tf/reorder-hub-orders-page-entrypoint";
import { Route, Switch } from "react-router-dom";
import GlobalSidecartPage from "@faire/prototype-playground/workspace/tf/global-sidecart";

export function TomFischerRoutes() {
  return (
    <Switch>
      <Route path="/tf/global-sidecart" component={GlobalSidecartPage} />
      <Route
        path="/tf/reorder-hub-orders-page-entrypoint"
        component={ReorderHubOrdersPageEntrypointPage}
      />
      <Route
        path="/tf/reorder-hub-organize-by-brand"
        component={ReorderHubOrganizeByBrandPage}
      />
    </Switch>
  );
}

export const slug = "tf";
